/**
 * Form Component
 * Form composition and layout components
 */

import React from "react";

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
  layout?: "vertical" | "horizontal" | "inline";
  spacing?: "tiny" | "small" | "medium" | "large" | "extraLarge";
  className?: string;
}

export interface FormSectionProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
}

export interface FormFieldProps {
  children: React.ReactNode;
  label?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  layout?: "vertical" | "horizontal";
  className?: string;
}

export function Form({
  children,
  layout = "vertical",
  spacing = "medium",
  className,
  ...props
}: FormProps) {
  // Implementation will be added later
  return (
    <form className={className} {...props}>
      {children}
    </form>
  );
}

function FormSection({
  children,
  title,
  description,
  className,
  ...props
}: FormSectionProps) {
  return (
    <div className={className} {...props}>
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {children}
    </div>
  );
}

function FormField({
  children,
  label,
  required,
  error,
  helperText,
  layout = "vertical",
  className,
  ...props
}: FormFieldProps) {
  return (
    <div className={className} {...props}>
      {label && (
        <label>
          {label}
          {required && <span>*</span>}
        </label>
      )}
      {children}
      {helperText && !error && <span>{helperText}</span>}
      {error && <span>{error}</span>}
    </div>
  );
}

// Add compound component properties
(Form as any).Section = FormSection;
(Form as any).Field = FormField;
